// Mock data for LOANYARD CAPITAL website

export const loanTypes = [
  {
    id: 1,
    title: "Home Loan",
    slug: "home-loan",
    description: "Realize your dream of owning a home with our flexible home loan options at competitive interest rates.",
    interestRate: "7.1% onwards",
    maxAmount: "₹5 Crore",
    tenure: "Up to 30 years",
    features: ["Minimal documentation", "Quick approval in 48 hours", "Flexible repayment options", "Balance transfer facility"]
  },
  {
    id: 2,
    title: "Loan Against Property",
    slug: "loan-against-property",
    description: "Unlock the value of your property to meet your financial needs with our loan against property.",
    interestRate: "8.5% onwards",
    maxAmount: "₹10 Crore",
    tenure: "Up to 20 years",
    features: ["High loan amount", "Competitive rates", "Multiple end-use options", "Overdraft facility available"]
  },
  {
    id: 3,
    title: "Business Loan",
    slug: "business-loan",
    description: "Grow your business with our customized business loan solutions designed for entrepreneurs.",
    interestRate: "13% onwards",
    maxAmount: "₹2 Crore",
    tenure: "Up to 10 years",
    features: ["Working capital support", "Fast disbursement in 3 days", "Flexible collateral options", "No hidden charges"]
  },
  {
    id: 4,
    title: "Personal Loan",
    slug: "personal-loan",
    description: "Get instant funds for your personal needs with our hassle-free personal loan process.",
    interestRate: "11.0% onwards",
    maxAmount: "₹40 Lakhs",
    tenure: "Up to 7 years",
    features: ["Instant approval in 2 hours", "No collateral required", "Minimal documentation", "Flexi payment options"]
  },
  {
    id: 5,
    title: "Balance Transfer",
    slug: "balance-transfer",
    description: "Switch your existing loan to us and enjoy lower EMIs and better interest rates.",
    interestRate: "8.0% onwards",
    maxAmount: "₹10 Crore",
    savings: "Save up to ₹5 Lakhs",
    tenure: "Up to 30 years",
    features: ["Lower interest rates", "Reduced EMI burden", "Top-up loan available", "Zero foreclosure charges"]
  }
];

export const benefits = [
  {
    id: 'quick-approval',
    title: "Quick Approval",
    description: "Get your loan approved within 24-48 hours with our streamlined process"
  },
  {
    id: 'competitive-rates',
    title: "Competitive Rates",
    description: "Enjoy some of the best interest rates in the market tailored to your needs"
  },
  {
    id: 'flexible-tenure',
    title: "Flexible Tenure",
    description: "Choose repayment tenure that suits your financial situation"
  },
  {
    id: 'minimal-documentation',
    title: "Minimal Documentation",
    description: "Simple and hassle-free documentation process for quick processing"
  },
  {
    id: 'expert-guidance',
    title: "Expert Guidance",
    description: "Our financial experts guide you through every step of the loan process"
  },
  {
    id: 'doorstep-service',
    title: "Doorstep Service",
    description: "We bring our services to your doorstep for your convenience"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    role: "Business Owner, Mumbai",
    rating: 5,
    text: "LOANYARD CAPITAL helped me expand my business with their quick and hassle-free business loan. The team was professional and supportive throughout."
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Software Engineer, Bangalore",
    rating: 5,
    text: "Got my home loan approved in just 3 days! The interest rates were competitive and the process was transparent. Highly recommended!"
  },
  {
    id: 3,
    name: "Amit Patel",
    role: "Entrepreneur, Delhi",
    rating: 5,
    text: "The loan against property helped me during a financial crunch. Great rates and excellent customer service from the LOANYARD team."
  },
  {
    id: 4,
    name: "Sneha Reddy",
    role: "Teacher, Hyderabad",
    rating: 5,
    text: "Personal loan process was so smooth! Got approval within 2 hours and money in my account the next day. Thank you LOANYARD!"
  },
  {
    id: 5,
    name: "Vikram Singh",
    role: "CA, Pune",
    rating: 5,
    text: "Balance transfer saved me ₹3 lakhs in interest. The team explained everything clearly and handled all paperwork."
  }
];

export const stats = [
  { id: 'years-experience', value: "15+", label: "Years Experience" },
  { id: 'financing-facilitated', value: "₹500+ Cr", label: "Financing Facilitated" },
  { id: 'corporate-clients', value: "500+", label: "Corporate Clients" },
  { id: 'pan-india', value: "Pan-India", label: "Execution" }
];

export const partnerBanks = [];

export const faqs = [
  {
    id: 1,
    question: "How long does loan approval take?",
    answer: "Most loans are approved within 24-48 hours once all documents are submitted. Personal loans can be approved even faster, within 2-3 hours."
  },
  {
    id: 2,
    question: "What documents are required for a home loan?",
    answer: "Basic documents include: Identity proof (Aadhaar/PAN), Address proof, Last 6 months salary slips, 1 year bank statement, property documents, and Form 16."
  },
  {
    id: 3,
    question: "Can I get a loan if I'm self-employed?",
    answer: "Yes! We offer loans to both salaried and self-employed individuals. For self-employed, we require 2 years ITR, business proof, and bank statements."
  },
  {
    id: 4,
    question: "What is the minimum credit score required?",
    answer: "Generally, a credit score of 750+ gets you the best rates. However, we work with scores as low as 650 depending on the loan type and other factors."
  },
  {
    id: 5,
    question: "Are there any hidden charges?",
    answer: "No hidden charges! All fees including processing fees, prepayment charges, and other costs are clearly disclosed upfront."
  },
  {
    id: 6,
    question: "Can I prepay my loan without penalty?",
    answer: "Yes, most of our loan products allow prepayment. Terms vary by lender, but we ensure you get the best prepayment terms available."
  },
  {
    id: 7,
    question: "How does balance transfer save money?",
    answer: "By transferring your existing loan to a lender with lower interest rates, you can reduce your EMI or loan tenure, potentially saving lakhs in interest."
  }
];

export const howItWorks = [
  {
    id: 'step-1',
    step: 1,
    title: "Apply Online",
    description: "Fill our simple 2-minute application form with basic details"
  },
  {
    id: 'step-2',
    step: 2,
    title: "Compare Offers",
    description: "Review personalized financing solutions and choose the best fit"
  },
  {
    id: 'step-3',
    step: 3,
    title: "Get Your Loan",
    description: "Complete documentation and receive funds in your account"
  }
];

export const employeeEmails = {
  general: "info@loanyardcapital.com",
  support: "support@loanyardcapital.com",
  applications: "apply@loanyardcapital.com",
  homeLoan: "homeloan@loanyardcapital.com",
  businessLoan: "businessloan@loanyardcapital.com",
  personalLoan: "personalloan@loanyardcapital.com",
  sales: "sales@loanyardcapital.com",
  partnerships: "partners@loanyardcapital.com"
};
